import userStateApi from '@/api/userState.api'

import { defaultUserState } from '@/constants'

const state = {
  userState: defaultUserState
}


const getters = {
  userState: (state) => {
    return state.userState
  }
}


const actions = {
  async loadUserState ({ commit, rootState }) {
    try {
      const response = await userStateApi.getUserState(rootState.tenant.current)
      commit('SET_USER_STATE', response.data)
    } catch (error) {
      commit('SET_USER_STATE', defaultUserState)
    }
  },


  async updateUserState ({ commit, rootState }, userStateUpdatedPart) {
    const updatedUserState = { ...state.userState }
    for (const [key, value] of Object.entries(userStateUpdatedPart)) {
      updatedUserState[key] = value
    }
    try {
      const response = await userStateApi.setUserState(rootState.tenant.current, updatedUserState)
      const userState = response.data
      commit('SET_USER_STATE', userState)
    } catch (error) {
      console.info(error)
    }
  }
}


const mutations = {
  SET_USER_STATE (state, userState) {
    state.userState = { ...userState }
  }
}


export default {
  state,
  getters,
  actions,
  mutations
}
